export default __webpack_public_path__ + "static/media/prada1.64b6a8b5.jpg";